import { guid4, ROOT_OUTPUT } from 'shared-base';
import { palettes } from '../data/data.palettes';
import { Json } from '../types';
import { arrayToObject } from './object';

export const parsePack = (pack: Json) => {
  const { sceneData } = pack;
  const { Objects } = sceneData;

  pack.models = arrayToObject(Objects.map((o: any, index: number) => parseModel(o, index)));
  delete pack.sceneData;

  return pack;
};

export const parseModel = (model: Json, index: number) => {
  const { ID, Palette, SliderValues, WackModifiers } = model;

  return {
    id: guid4(),
    name: '',
    generatorId: ID,
    generatorUrl: `${ROOT_OUTPUT}/${ID}.template.json`,
    thumbnail: '',
    modifiedAt: new Date().toISOString(),
    materials: parseMaterials(Palette),
    valuesModel: SliderValues,
    modifiers: parseWackModifiers(WackModifiers),
  };
};

export const parseMaterials = (paletteId: string) => {
  const palette = palettes[paletteId];
  if (!palette) return {};
  return palette.materials ?? {};
};

export const parseWackModifiers = (wackModifiers: any) => {
  return Object.keys(wackModifiers).reduce((acc, key) => {
    const newKey = seqMap[key];
    acc[newKey] = wackModifiers[key];
    return acc;
  }, {} as Json);
};

export const seqMap: any = {
  0: 'modifiersWack_Influence',
  1: 'modifiersWack_OffsetX',
  2: 'modifiersWack_OffsetY',
  3: 'modifiersWack_OffsetZ',
  4: 'modifiersWack_ScaleX',
  5: 'modifiersWack_ScaleY',
  6: 'modifiersWack_ScaleZ',
  7: 'modifiersWack_RotateX',
  8: 'modifiersWack_RotateY',
  9: 'modifiersWack_RotateZ',
  10: 'modifiersWack_TaperTopX',
  11: 'modifiersWack_TaperTopY',
};
